import styled from 'styled-components';
import { font } from 'styles/globals';
import { Theme, getBodyStyle, getColor } from 'styles/theme';
import * as S from 'components/Placeholder/PlaceholderStyles';
import { getIcon } from 'styles/icons';

export const Wrapper = styled.div<{ theme: Theme }>`
  position: relative;
  font-family: ${font.graphikCond};
  width: 100%;
  padding: 16px;
  background: ${getColor('surfaceWhite')};
  box-shadow: 4px 4px 20px 0px ${getColor('textPrimary')}0D;

  &.loading {
    min-height: 178px;
    &:before {
      content: '';
      ${S.loadingBackground}
      position: absolute;
      width: 100%;
      height: 100%;
      z-index: 9;
      top: 0;
      right: 0;
    }
  }
    
`;
export const TitleContainer = styled.div<{ theme: Theme }>`
  display: flex;
  padding-bottom: 16px;
  border-bottom: solid 1px ${getColor('borderSecondary')};

  .checkmark-badge {
    padding: 0 8px 0 0;
    max-height: 24px;
  }
`;

export const Title = styled.a<{ theme: Theme }>`
  color: ${getColor('textPrimary')};
  text-decoration: none;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 120%; /* 24px */
  letter-spacing: 0.5px;
`;

export const ToolTip = styled.div<{ theme: Theme }>`
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 48px;
  z-index: 1;
  max-width: 95%;
  background-color: ${getColor('surfaceWhite')};
  box-shadow: 2px 2px 4px 0px ${getColor('textPrimary')}26;
  border-top: solid 4px ${getColor('borderAccentPrimary')};
  padding: 4px 8px 16px 16px;

  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 21px */
  letter-spacing: 0.5px;
  align-self: stretch;

`;

export const CloseToolTip = styled.button<{ theme: Theme }>`
  max-width: 18px;
  max-height: 18px;
  justify-content: flex-end;
  margin-left: auto;

  ${getIcon('svg-states')};

  &::before {
    ${getIcon('close-icon', { height: 19, width: 18 })};
    background-color: ${getColor('neutralBlack')}
  };
`;

export const ListContainer = styled.div<{ theme: Theme }>`
  display: flex;
  flex-flow: column;
  gap: 4px;
  margin: 16px 0;
`;

export const ListRow = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const ListCategory = styled.p<{ theme: Theme }>`
  ${getBodyStyle('graphikCond', { default: 'default' }, 'semiBold')};
`;

export const ListItem = styled.p<{ theme: Theme }>`
  ${getBodyStyle('graphikCond', { default: 'default' }, 'regular')};
  text-align: right;
`;
